<template>
	<BuyersOrderGroup name="Inceptions">
		<template #right-icon>
			<span></span>
		</template>

		<template #column-3>
			<InputCurrency
				:saturn="bo.finalNumbers.leaseFinalNumbers.inceptions"
				:disabled="true"
				:precision="2"
				iconSide="left"
				:negative="true"
			>
			</InputCurrency>
		</template>

		<template #children>
			<BuyersOrderRow
				v-for="inceptionItem in bo.finalNumbers.leaseFinalNumbers.inceptionsBreakdown"
				:key="inceptionItem.name"
				hideExtraColumns
			>
				<template #info>
					<span>{{ inceptionItem.name }}</span>
				</template>

				<template #right-icon>
					<span></span>
				</template>

				<template #column-1>
					<InputCurrency
						:saturn="inceptionItem.amount"
						:disabled="true"
						:precision="2"
						iconSide="left"
						:negative="true"
					/>
				</template>
			</BuyersOrderRow>
		</template>
	</BuyersOrderGroup>
</template>

<script setup lang="ts">
	import BuyersOrderGroup from './BuyersOrderGroup.vue';
	import BuyersOrderRow from './BuyersOrderRow.vue';
	import FIMenuBuyersOrder from '@core/classes/FIMenuBuyersOrder';
	import InputCurrency from '@core/components/InputCurrency.vue';

	interface IBuyersOrderInceptionsProps {
		bo: FIMenuBuyersOrder;
	}

	const { bo } = defineProps<IBuyersOrderInceptionsProps>();
</script>

<style scoped></style>
